import React, { Component } from 'react';

class ReviewAverageComponent extends Component {
  constructor(props) {
    super(props);
  }

  calculateAverageRating(reviews) {
    let reviewRatings = reviews.map(review => (review.values.reduce((total, num) => { return total + num; }) / review.values.length));
    return (reviewRatings.reduce((total, num) => { return total + num; }) / reviewRatings.length).toFixed(1);
  }

  renderStarValue(value, renderSmall = false) {
    let valueDom = []
    for (let i = 0; i < 5; i++) {
      if (value - i >= 1) { valueDom.push(<i key={`star_${i}`} className={`fas fa-star${renderSmall ? '' : ' fa-2x'}`} />); }
      else if (value - i >= .3) { valueDom.push(<i key={`star_${i}`} className={`fas fa-star-half-alt${renderSmall ? '' : ' fa-2x'}`} />); }
      else { valueDom.push(<i key={`star_${i}`} className={`far fa-star${renderSmall ? '' : ' fa-2x'}`} />); }
    }
    return (<div>{valueDom}</div>);
  }

  render() {
    let { reviews, averageRating, starsOnly } = this.props;
    if (starsOnly) {
      return (!reviews || reviews.length === 0) ? this.renderStarValue(0, true) : this.renderStarValue(averageRating, true);
    }
    if (!reviews || reviews.length === 0) return (
      <div className="row">
        <div className="col-12 d-flex">
          <div className="pr-2">{this.renderStarValue(0)}</div>
          <div className="mt-3">(0 reviews)</div>
        </div>
        <div className="col-12">Average Rating: <strong>N/A</strong></div>
      </div>);
    let viewAvgRating = averageRating ? averageRating : this.calculateAverageRating(reviews);
    let reviewText = reviews.length > 1 ? "reviews" : "review";
    return (<div className="row">
      <div className="col-12 d-flex">
        <div className="pr-2">{this.renderStarValue(viewAvgRating)}</div>
        <span className="mt-3">({reviews.length} {reviewText})</span>
      </div>
      <div className="col-12">Average Rating: <strong>{viewAvgRating}</strong></div>
    </div>);
  }
}

export default ReviewAverageComponent;
